import React from 'react'
import CreateUserForm from './UserForm'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'
import _ from 'lodash'
import moment from 'moment'

export default class UserComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ user: '', isUpdate: false })
  }

  componentWillMount () {
    if (!_.isEmpty(this.props.params)) {
      console.log(this.props.params)
      this.setState({ user: this.props.params.user, isUpdate: true })
    }
  }

  render () {
    document.title = 'Registrar Usuario - CORE 3.0'
    return (
      <CreateUserForm userId={this.state.user} isUpdate={this.state.isUpdate} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UserComponent.js